import React from 'react';
import { Link } from 'gatsby';
import { getGcUi } from '../../constants/spanish-gc';
import BookIconWhite from '../../images/svg-gcbooks/book-icon';
import './ChapterSummaryByline.scss';

const contentColumnWrap = (byline, lineageRead = false, afterTitle = false) => {
  if (lineageRead && afterTitle) {
    return byline;
  }

  if (lineageRead) {
    return (
      <div className="wrapper wrapper-md pd-x-sm gc-chapter-summary-byline-column gc-chapter-summary-byline-column--read gc-chapter-summary-byline-column--lineage">
        <div className="wrapper-sm gc-chapter-summary-byline-column__inner read-single-content-align">{byline}</div>
      </div>
    );
  }

  return (
    <div className="wrapper wrapper-md gc-chapter-summary-byline-column gc-chapter-summary-byline-column--read">
      <div className="wrapper-sm gc-chapter-summary-byline-column__inner">
        <div className="r_s_c_inner">{byline}</div>
      </div>
    </div>
  );
};

export default function ChapterSummaryByline({
  locale = 'en',
  beforeBody = false,
  contentLayout,
  readMoreHref,
  onReadMoreClick,
  summaryLabel,
  authorName,
  readCompleteLabel,
  readMoreLabel,
  lineageRead = false,
  afterTitle = false,
}) {
  const ui = getGcUi(locale);
  const showCta = Boolean(readMoreHref || onReadMoreClick);
  const label = summaryLabel ?? ui.chapterSummaryLabel;
  const author = authorName ?? ui.chapterSummaryAuthor;
  const completeLabel = readCompleteLabel ?? ui.readCompleteChapterLabel;
  const moreLabel = readMoreLabel ?? ui.readMore;

  const readMoreButton = (
    <>
      <span className="gc-chapter-summary-byline__read-more-btn-icon" aria-hidden="true">
        <BookIconWhite color="#0a0a0a" viewBox="4 5 24 22" />
      </span>
      <span className="gc-chapter-summary-byline__read-more-btn-label">{moreLabel}</span>
    </>
  );

  const authorOnly = Boolean(lineageRead);

  const byline = authorOnly ? (
    <div
      className={`gc-chapter-summary-byline gc-chapter-summary-byline--author-only${
        contentLayout ? ' gc-chapter-summary-byline--in-content' : ''
      }${beforeBody ? ' gc-chapter-summary-byline--before-body' : ''}`}
    >
      <p className="gc-chapter-summary-byline__author-name">{author}</p>
    </div>
  ) : (
    <div
      className={`gc-chapter-summary-byline${contentLayout ? ' gc-chapter-summary-byline--in-content' : ''}${
        beforeBody ? ' gc-chapter-summary-byline--before-body' : ''
      }${showCta ? ' gc-chapter-summary-byline--with-cta' : ''}`}
      aria-labelledby="gc-chapter-summary-label"
    >
      <div className="gc-chapter-summary-byline__main">
        <div className="gc-chapter-summary-byline__row">
          <div className="gc-chapter-summary-byline__accent" aria-hidden="true" />
          <p className="gc-chapter-summary-byline__label" id="gc-chapter-summary-label">
            {label}
          </p>
        </div>
        <p className="gc-chapter-summary-byline__author">
          <span className="gc-chapter-summary-byline__by">{ui.chapterSummaryBy} </span>
          <span className="gc-chapter-summary-byline__author-name">{author}</span>
        </p>
      </div>
      {showCta ? (
        <div className="gc-chapter-summary-byline__actions">
          <p className="gc-chapter-summary-byline__read-more-lead">
            <span className="gc-chapter-summary-byline__read-more-label">{completeLabel}</span>
            <span className="gc-chapter-summary-byline__read-more-arrow" aria-hidden="true">
              {' '}
              →
            </span>
          </p>
          {readMoreHref ? (
            <Link to={readMoreHref} className="btn btn-sm gcslogan gc-chapter-summary-byline__read-more-btn">
              {readMoreButton}
            </Link>
          ) : (
            <button
              type="button"
              className="btn btn-sm gcslogan gc-chapter-summary-byline__read-more-btn"
              onClick={onReadMoreClick}
            >
              {readMoreButton}
            </button>
          )}
        </div>
      ) : null}
    </div>
  );

  if (contentLayout === 'read') {
    if (lineageRead && afterTitle) {
      return (
        <div className="gc-chapter-summary-byline-section gc-chapter-summary-byline-section--lineage-after-title">
          {contentColumnWrap(byline, lineageRead, true)}
        </div>
      );
    }

    return (
      <div
        className={`bg-light gc-chapter-summary-byline-section${
          lineageRead ? ' gc-chapter-summary-byline-section--lineage' : ''
        }`}
      >
        {contentColumnWrap(byline, lineageRead)}
      </div>
    );
  }

  if (contentLayout === 'study') {
    return (
      <div className="gc-chapter-summary-byline-section bg-light">
        <div className="gc-text-section-padding gc-chapter-summary-byline-column gc-chapter-summary-byline-column--study">
          <div className="wrapper" style={{ display: 'flex', margin: 'auto' }}>
            <div className="r_s_inner">{byline}</div>
          </div>
        </div>
      </div>
    );
  }

  return byline;
}
